import {SEGMENTS_WARNING_MESSAGE} from '@/utils/constants/commonConstants';

// Section titles and labels used across RewardReview components
export const SECTION_TITLES = {
  SETUP: {
    MAIN: 'Setup',
    REWARD_CONDITIONS: 'Reward Conditions',
    PRODUCTS: 'Products',
    DIGITAL_CODES: 'Digital Codes',
    SEGMENTS: 'Segments'
  },
  DISPLAY: {
    MAIN: 'Display',
    REWARD_CARD: 'Reward Card',
    REWARD_TEXT: 'Reward Text',
    REWARD_IMAGES: 'Reward Images',
    LANGUAGES: 'Languages',
    CREATE_REWARDS: 'Create Reward',
    REWARD_REVIEW: 'Reward Review',
    DUPLICATE_REWARD: 'Duplicate',
    DOWNLOAD_REWARD: 'Download',
    LAST_UPDATED: 'Last Updated',
    REVOKE: 'Revoke'
  },
  ATTRIBUTES: {
    MAIN: 'Attributes',
    AVAILABILITY: 'Availability',
    ADDITIONAL_ATTRIBUTES: 'Additional Attributes'
  }
};

// Field labels used across components
export const FIELD_LABELS = {
  SETUP: {
    REWARD_NAME: 'Name',
    REWARD_TYPE: 'Reward Type',
    CARD_TYPE: 'Card Type',
    NAME: 'Reward Name',
    REWARD_ID: 'Reward ID',
    REWARD: 'Reward',
    LOYALTY_URL: 'Loyalty URL',
    COUPON_BASED_LOYALTY_REWARD: 'Coupon Based Loyalty Reward',
    ALL_CUSTOMERS: 'All Customers',
    GROUPS: 'Groups',
    EXCLUDING: 'Excluding'
  },
  DISPLAY: {
    PRODUCT_NAME: 'Product Name',
    DEFAULT_IMAGE: 'Default Image',
    ALERT_DISPLAY_COUNT: 'Alert Display Count',
    SHOWN_ON_HOMEPAGE: 'Shown on Homepage',
    TITLE: 'Title',
    DESCRIPTION: 'Description',
    SUPPORTED_LANGUAGES: 'Supported Languages'
  },
  ATTRIBUTES: {
    START_DATE: 'Start Date',
    END_DATE: 'End Date',
    DISPLAY_OUT_OF_STOCK: 'Display Out of Stock',
    IN_STOCK: 'In Stock',
    QUOTA: 'Quota',
    LEFTOVER_INVENTORY: 'Leftover Inventory',
    LIMIT_PER_STORE: 'Limit per Store',
    MAX_QUANTITY_PER_ORDER: 'Max Quantity per Order',
    UNLIMITED_INVENTORY: 'Unlimited Inventory'
  }
};

// Default values and fallback text
export const DEFAULT_VALUES = {
  FALLBACK: '-',
  NO_CONTENT: 'No content available',
  NO_SEGMENTS: 'No segments selected',
  UNLIMITED: 'Unlimited',
  YES: 'Yes',
  NO: 'No'
};

// Info messages and help text
export const INFO_MESSAGES = {
  SEGMENTS_WARNING: SEGMENTS_WARNING_MESSAGE
};
